/**
 * The face-down card back in the picker (recipient polish N3, 2026-11-02).
 *
 * The reader's own back can be a large PNG straight from blob storage: until it
 * paints, the card wears a painted placeholder back (SelectCards .back-loading).
 * A back that fails to load falls back to the default back; if that fails too,
 * '' means "no image": the painted placeholder stays.
 */
export const DEFAULT_CARD_BACK = 'https://mysticaidablob.blob.core.windows.net/public/reader_backgrounds/Master_Lee_4_oWt7iSD.png'

export function nextCardBack (failed) {
  return failed && failed !== DEFAULT_CARD_BACK ? DEFAULT_CARD_BACK : ''
}
